import type { InternalDropdownOptions } from '~/chords/DropdownSingleSelect/types';

interface UpdateSelectedOptionsParams {
  prevSelectedOptionIndex?: number;
  newSelectedOptionIndex: number;
}

/**
 * Update the options in the dropdown based on the selected option.
 * @param prevOptions - The previous options in the dropdown.
 * @param param1.prevSelectedOptionIndex - The previously selected option's index, if any.
 * @param param1.newSelectedOptionIndex - The newly selected option's index.
 * @returns The updated options.
 */
export function updateSelectedOptions(
  prevOptions: InternalDropdownOptions,
  {
    prevSelectedOptionIndex,
    newSelectedOptionIndex,
  }: UpdateSelectedOptionsParams,
) {
  const newOptions = structuredClone(prevOptions);

  return newOptions.map((group) => {
    const internalOptionsGroup = 'options' in group ? group.options : group;
    const updatedOptionsGroup = internalOptionsGroup.map((option) => {
      let isSelected = option.isSelected;

      if (prevSelectedOptionIndex !== undefined) {
        if (option.optionIndex === prevSelectedOptionIndex) {
          isSelected = false;
        }
      }

      if (option.optionIndex === newSelectedOptionIndex) {
        isSelected = true;
      }

      return {
        ...option,
        isSelected,
      };
    });

    if ('options' in group) {
      return {
        ...group,
        options: updatedOptionsGroup,
      };
    }

    return updatedOptionsGroup;
  });
}
